import React, { useMemo } from 'react';
import { WORKFLOW_STATE_OPTIONS, formatStatus } from '../constants/workflowLabels';

const STATUS_CLASS = {
  intake: 'rhs-badge--intake',
  under_review: 'rhs-badge--review',
  notice_sent: 'rhs-badge--notice',
  violation_open: 'rhs-badge--violation',
  payment_pending: 'rhs-badge--payment',
  resolved: 'rhs-badge--resolved',
  closed: 'rhs-badge--closed',
  appealed: 'rhs-badge--appeal',
};

/**
 * GOVOPS-1111 — unified workflow status counts (permits + cases + violations).
 */
const WorkflowStatusBoard = ({ totals = {} }) => {
  const max = useMemo(() => {
    const vals = WORKFLOW_STATE_OPTIONS.map((s) => totals[s] || 0);
    return Math.max(1, ...vals);
  }, [totals]);

  const grandTotal = useMemo(
    () => WORKFLOW_STATE_OPTIONS.reduce((n, s) => n + (totals[s] || 0), 0),
    [totals]
  );

  return (
    <section className="rhs-card rhs-workflow-status-board" aria-labelledby="workflow-status-heading">
      <h2 id="workflow-status-heading" className="rhs-card-title">
        Workflow status breakdown
      </h2>
      <p className="rhs-muted rhs-card-lead">
        Combined permits, cases, and violations in your organization ({grandTotal} records).
      </p>
      {grandTotal === 0 ? (
        <div className="rhs-empty-state rhs-empty-state--compact">
          <p className="rhs-muted">
            No operational records yet. Submit a permit or run{' '}
            <code>npm run setup:govops:demo</code> to seed pilot data.
          </p>
        </div>
      ) : (
        <ul className="rhs-workflow-status-grid">
          {WORKFLOW_STATE_OPTIONS.map((status) => {
            const count = totals[status] || 0;
            return (
              <li
                key={status}
                className={`rhs-workflow-status-item rhs-workflow-status-item--${status}`}
              >
                <span className={`rhs-badge ${STATUS_CLASS[status] || 'rhs-badge--default'}`}>
                  {formatStatus(status)}
                </span>
                <span className="rhs-workflow-status-bar-wrap" aria-hidden="true">
                  <span
                    className="rhs-workflow-status-bar"
                    style={{ width: `${Math.round((count / max) * 100)}%` }}
                  />
                </span>
                <span className="rhs-workflow-status-count">{count}</span>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
};

export default WorkflowStatusBoard;
